export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img2-6d8c07f02df9908eafcd23c4f2e20f34.png";